import React from "react";
import tangibleImg from "../../images/TangibleTank.png";

const styles = {
  tangibleImage: { width: "200px", height: "auto" },
  hideDiv: {
    height: 0,
    maxHeight: 0,
    display: "none",
    overflow: "hidden",
    padding: "0px",
    boxShadow: "none",
  },
};

const TangibleDescription = ({ expanded, setExpanded, showTangDesc }) => {
  return (
    <div
      className={`descriptionContainer ${expanded && "expanded"}`}
      style={showTangDesc ? { flex: 1, display: "flex" } : styles.hideDiv}
    >
      <p className="headerText">The Tangibles</p>
      <div className="customHl" />
      <div className="descriptionImageWrapper">
        <img
          src={tangibleImg}
          alt="tangibleTank"
          style={styles.tangibleImage}
        />
      </div>
      {expanded ? (
        <p className="descriptionText">
          The iPad screen is a so-called Capacitive touch screen. The screen
          detects disturbance in its static electric field and by a grid system
          detect where on the screen the disturbance was introduced. This is
          what happens when you touch the screen with your fingers. To emulate a
          finger you need some material where the electrons can move easily and
          also a larger amount of them. We covered small cylindrical bits of
          plastic with a conductive textile to act as the touch point on the
          screen and connected the fabric to copper wires. The tangibles were
          then designed into different shapes and decorated with copper wires on
          the outside that connect to the copper on the inside to introduce even
          more capacitance when touched. Each tangible has three touch points.
          The three points are placed in a right angled triangle. With the
          different attributes of the triangles we are able to calculate the
          tangibles type, position and rotation.
        </p>
      ) : (
        <React.Fragment>
          <p className="descriptionText">
            The thing that sets this game apart from most other tablet based
            games are our custom made tangibles! Using passive technology, 3D
            printed models and our own unique script for detection we've managed
            to create a game that extends beyond the boundaries of the screen.
          </p>
          <p className="descriptionText">
            Getting to hold objects from the game in your hands while playing
            brings immersion to the next level. Click down below to find out
            more how we did it!
          </p>
        </React.Fragment>
      )}

      <button
        className="readMoreButton"
        onClick={() => setExpanded(expanded ? false : "Tangible")}
      >
        {expanded ? "Close" : "Read More"}
      </button>
    </div>
  );
};

export default TangibleDescription;
